import { createContext, ReactNode, useContext, useEffect, useState } from 'react'
import { useRouteMatch } from 'react-router-dom'

import { useWindowView } from 'hooks'
import { paths } from 'app/paths'

const pathsWithClosedMenu = [
    paths.editPlaylist,
    paths.playlistDetails,
    paths.editPlaybook,
    paths.playbookDetails,
    paths.editQuickGuidde,
    paths.searchPlaybook,
    paths.searchPlaylist
]

const MenuStatusContext = createContext({
    isMenuClosed: false,
    setIsMenuClosed: (_value: boolean) => {},
    initiallyClosed: false
})

export const useMenuStatus = () => useContext(MenuStatusContext)

type ProviderProps = {
    children: ReactNode
}

export const MenuStatusProvider = ({ children }: ProviderProps) => {
    /**
     * In playbooks pages - the menu should be closed by default. Therefore, in addition to
     * checking the window size - we will check if the page is playbook.
     * Since we are adding a hover state - and it is on this component and not on its
     * children - and since local/session storage working only when moving tabs in the broswer -
     * the solution is to create a new event that the children components will 'listen' to it
     */

    const { shouldCollapseMenu } = useWindowView()

    const existsInPathsWithClosedMenu = useRouteMatch(pathsWithClosedMenu)?.isExact

    const initiallyClosed = existsInPathsWithClosedMenu || shouldCollapseMenu

    const [isMenuClosed, setIsMenuClosed] = useState(initiallyClosed)

    useEffect(() => {
        setIsMenuClosed(initiallyClosed)
    }, [initiallyClosed])

    return (
        <MenuStatusContext.Provider value={{ setIsMenuClosed, isMenuClosed, initiallyClosed }}>
            {children}
        </MenuStatusContext.Provider>
    )
}
